import { MutationTree } from 'vuex';
import IRequestState from './types/IRequestState';
import IRequestMeta from './types/IRequestMeta';
import IRequestForm from './types/IRequestForm';
import IRequestHeader from './types/IRequestHeader';

const mutations: MutationTree<IRequestState> = {
  setMeta(state, meta: IRequestMeta) {
    state.meta = meta;
  },

  setHeader(state, header: IRequestHeader) {
    state.header = header;
  },

  setForm(state, form: IRequestForm) {
    state.form = form;
  },
};

export default mutations;
